<div *ngIf="maintenance" class="single-chat-page">

  <!-- Maintenance report -->
  <app-scotty-card [title]="'Maintenance report' | translate" [fullHeight]="true" canGoBack="true">

    <div class="row">

      <div class="col">
        <div class="group-title">{{ 'Asset informations' | translate }}</div>
        <div class="group">
          <div class="icon-with-label"><mat-icon color="primary">edit</mat-icon> {{maintenance.equipment.model.name}}</div>
          <div class="icon-with-label"><mat-icon color="primary">qr_code</mat-icon> {{maintenance.equipment.serialNumber}}</div>
        </div>
      </div>

      <div class="col">
        <div class="group-title">{{ 'Maintenance informations' | translate }}</div>
        <div class="group">
          <div *ngIf="maintenance.fieldWorker else noFieldWorker" class="icon-with-label"><mat-icon color="primary">person</mat-icon> {{ 'Field worker' | translate }}: {{maintenance.fieldWorker.name}}</div>
          <ng-template #noFieldWorker>
            <div class="icon-with-label"><mat-icon color="primary">person</mat-icon> <i>{{ 'No field worker binded' | translate }}. <a [routerLink]="['../..', 'calendar', 'event', maintenance.event.id]">{{ 'Assign now' | translate }}</a></i></div>
          </ng-template>
          <div *ngIf="maintenance.fieldWorker && maintenance.remoteExpert" class="icon-with-label"><mat-icon color="primary">support_agent</mat-icon> {{ 'Remote expert' | translate }}: {{maintenance.remoteExpert.name}}</div>
          <div *ngIf="maintenance.assignedBy" class="icon-with-label"><mat-icon color="primary">person</mat-icon> {{ 'Assigned by' | translate }} {{maintenance.assignedBy.firstName}} {{maintenance.assignedBy.lastName}}</div>
          <div *ngIf="maintenance.assignedAt" class="icon-with-label"><mat-icon color="primary">access_time</mat-icon> {{ 'Assigned at' | translate }} {{maintenance.assignedAt | date:'medium'}}</div>
          <div class="icon-with-label"><mat-icon color="primary">access_time</mat-icon> {{ 'Scheduled at' | translate }} {{maintenance.scheduledAt | date:'medium'}}</div>
          <div class="icon-with-label"><mat-icon color="primary">access_time</mat-icon> {{ 'Created at' | translate }} {{maintenance.createdAt | date:'medium'}}</div>
        </div>
      </div>

      <div class="col">
        <div class="group-title">{{ 'Additional informations' | translate }}</div>
        <div class="group">
          <div class="icon-with-label"><mat-icon class="boolean-icon" [class.success]="!maintenance.isExtraordinary" [class.error]="maintenance.isExtraordinary">{{maintenance.isExtraordinary ? 'cancel' : 'check_circle'}}</mat-icon> {{(maintenance.isExtraordinary ? 'Not scheduled' : 'Scheduled') | translate}}</div>
          <!--<div class="icon-with-label"><mat-icon class="boolean-icon" [class.success]="!maintenance.live_assistance_required" [class.error]="maintenance.live_assistance_required">{{maintenance.live_assistance_required ? 'cancel' : 'check_circle'}}</mat-icon> {{(maintenance.live_assistance_required ? 'Live assistance required' : 'No live assistance required') | translate}}</div>-->
          <div class="icon-with-label"><mat-icon class="boolean-icon" [class.success]="maintenance.isBotEnabled" [class.error]="!maintenance.isBotEnabled">{{maintenance.isBotEnabled ? 'check_circle' : 'cancel'}}</mat-icon> {{ 'Chatbot only' | translate }}</div>
        </div>
      </div>

      <div class="col">
        <div class="group-title">{{ 'Tags' | translate }}</div>
        <div class="group">
          <span *ngIf="tags.length == 0">{{ 'No tags specified' | translate }}</span>
          <mat-chip-list
            *ngIf="tags.length > 0"
            class="tags"
            cdkDropList
            cdkDropListOrientation="horizontal">
            <mat-chip
              class="tags"
              *ngFor="let tag of tags">
              {{tag}}
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>

    </div>

    <!--<div class="group-title">Expert</div>
    <div class="group">
      <div class="icon-with-label"><mat-icon color="primary">person</mat-icon> {{maintenance.operatorUid}}</div>
      <div class="icon-with-label"><mat-icon color="primary">access_time</mat-icon> {{maintenance.created_at | date:'medium'}}</div>
    </div>-->

    <!--<ng-container *ngIf="maintenance.recordingUrl">
      <div class="group-title">Recorded maintenance</div>
      <div class="group">
        <div *ngIf="maintenance.recordingUrl.length == 0"><app-scotty-spinner [diameter]="25" [margin]="8" text="Your recording will be ready in a moment...<br>Try again in few minutes"></app-scotty-spinner></div>
        <div *ngIf="maintenance.recordingUrl.length > 0"><button mat-flat-button color="primary" class="expanded" (click)="playbackRecording()">Open maintenance video</button></div>
      </div>
    </ng-container>-->

  </app-scotty-card>

  <div class="row expand">

    <!-- Live chat -->
    <app-assistance-view
      *ngIf="maintenance.status == MaintenanceStatus.CLOSED && (maintenance.event.type != EventType.PLANNED_MAINTENANCE || (maintenance.event.type == EventType.PLANNED_MAINTENANCE && maintenance.isSupportRequired))"
      [assistance]="getAssistanceFromMaintenance()"
      [assistanceType]="AssistanceType.LIVE_MAINTENANCE"
      [canClose]="false"
    ></app-assistance-view>

    <!-- Maintenance procedure status -->
    <app-scotty-card class="work-instruction-live-status" #procedureStatusCard *ngIf="maintenance.procedure" title="Maintenance status" [fullHeight]="true" [hideDivisor]="true" [actions]="getProcedureCardActions()">
      <app-timeline *ngIf="progress && !updatingProcedure else loading" [groups]="progress"></app-timeline>
    </app-scotty-card>

    <!-- Maintenance video playback -->
    <app-video-playback
      [inProgress]="maintenance.status != MaintenanceStatus.CLOSED"
      [videoUrl]="maintenance.recordingUrl"
      (onBack)="stopPlayback()"
    ></app-video-playback>

  </div>

</div>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
